 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		10: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		10: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"4343389025c61f3a56b2a0053394160241322343","1":"fe898b8ed7c05eb13a67e4d86d228ef58d1cafe7","2":"fbb2bc29b821040dad69017cd0b630cc2156be02","3":"9a105258a3a163b871af95c83d26619c2c86248d","4":"d3196ab821b2eecd7078cfbf9f0fc289962f7010","5":"styles","6":"38387a7da99ff9ec323c8e5513da161da24e5940","7":"11dd2a487fbd0b2bc4903be47570e75ed3b372ab","8":"325e8fbac9e8e621cac8d1682aa7a88b146c49f1","9":"f767f3ab81c56a889b3661ba112fbe4febfbe8de","12":"9968412e","14":"component---toggl-src-case-studies-index-js","15":"component---toggl-src-ebooks-index-js","16":"component---toggl-src-invitation-index-js","17":"component---toggl-src-job-index-js","18":"component---toggl-src-pages-404-js","19":"component---toggl-src-pages-index-index-js","20":"component---toggl-src-pages-jobs-index-js","21":"component---toggl-src-pages-legal-js","22":"component---toggl-src-pages-mission-index-js","23":"component---toggl-src-pages-track-adobe-time-tracking-index-js","24":"component---toggl-src-pages-track-completed-signup-js","25":"component---toggl-src-pages-track-contact-js","26":"component---toggl-src-pages-track-customers-index-js","27":"component---toggl-src-pages-track-demo-request-confirmation-js","28":"component---toggl-src-pages-track-demo-request-js","29":"component---toggl-src-pages-track-device-unsupported-js","30":"component---toggl-src-pages-track-features-index-js","31":"component---toggl-src-pages-track-forgot-password-js","32":"component---toggl-src-pages-track-index-index-js","33":"component---toggl-src-pages-track-integrations-index-js","34":"component---toggl-src-pages-track-login-js","35":"component---toggl-src-pages-track-pricing-index-js","36":"component---toggl-src-pages-track-sso-link-account-js","37":"component---toggl-src-pages-track-sso-login-js","38":"component---toggl-src-pages-track-sso-must-link-js","39":"component---toggl-src-pages-track-toggl-button-login-js","40":"component---toggl-src-paid-ad-landing-pages-index-js","41":"component---toggl-src-personas-index-js","42":"component---toggl-src-signup-index-js","43":"component---toggl-src-templates-track-reset-password-js","44":"component---toggl-src-templates-track-unsubscribe-js","45":"component---toggl-src-webinars-index-js"}[chunkId]||chunkId) + "-" + {"0":"627dfd8f0d362bd2fc8b","1":"d1c019c4e7819abf7fdd","2":"b295327e0a5b0a76c3c2","3":"ca0ed7d28108961ba49b","4":"4aad9802a722ef9065a9","5":"29163f9dced6fe4a408a","6":"e7de9f78edc41baa0c59","7":"2050129d443ecfe6d3e3","8":"531a26a99103feee0588","9":"e463ed44c61660d4be22","11":"b20695995f4d488f43b3","12":"5d74a2acfadd47c96c99","14":"c3c205bfadd5b9996b47","15":"a74a317f3adf841abc38","16":"1cad6795f615dd3da759","17":"769f513ee6219569c57f","18":"ea8f769ac49403c24146","19":"d9a97154df1c2c5b7cfe","20":"c27ca80e0d318700eb46","21":"e56ce1d8084474fb4066","22":"9ee1fa2fc047f9a9d903","23":"f5db54f2456a58e18c5c","24":"c6fcd5326bad82ba2715","25":"a7341f9c28311f0251ad","26":"7b954c3822f9e7823516","27":"d072820d64eeeee9ffac","28":"8a4a851034b930776423","29":"714a62315aea71d97fc1","30":"e071dc4a529c9c18c5d8","31":"b63f7824db2b38071e10","32":"0e7395fbc43bdef9092d","33":"fc1f7ab2aea081e3ec9a","34":"f8512e5787b4f0559dd0","35":"1e4c8c787f40a103d949","36":"84b3da7718f6f580e05c","37":"667f196324f9d4d7c3dd","38":"1388394d4f187281a287","39":"c381150bd4edc96843d4","40":"f013e188f3bfa4764603","41":"09ef51d89b44f570e30e","42":"96c1e2aae71f50a76f84","43":"cbe1bdd7b92ef2587fa1","44":"c99cecaaa99b5a09d822","45":"2cc78f4ef7f2d8dfd62d","48":"7b9e6cfd312793704f07"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"5":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"4343389025c61f3a56b2a0053394160241322343","1":"fe898b8ed7c05eb13a67e4d86d228ef58d1cafe7","2":"fbb2bc29b821040dad69017cd0b630cc2156be02","3":"9a105258a3a163b871af95c83d26619c2c86248d","4":"d3196ab821b2eecd7078cfbf9f0fc289962f7010","5":"styles","6":"38387a7da99ff9ec323c8e5513da161da24e5940","7":"11dd2a487fbd0b2bc4903be47570e75ed3b372ab","8":"325e8fbac9e8e621cac8d1682aa7a88b146c49f1","9":"f767f3ab81c56a889b3661ba112fbe4febfbe8de","12":"9968412e","14":"component---toggl-src-case-studies-index-js","15":"component---toggl-src-ebooks-index-js","16":"component---toggl-src-invitation-index-js","17":"component---toggl-src-job-index-js","18":"component---toggl-src-pages-404-js","19":"component---toggl-src-pages-index-index-js","20":"component---toggl-src-pages-jobs-index-js","21":"component---toggl-src-pages-legal-js","22":"component---toggl-src-pages-mission-index-js","23":"component---toggl-src-pages-track-adobe-time-tracking-index-js","24":"component---toggl-src-pages-track-completed-signup-js","25":"component---toggl-src-pages-track-contact-js","26":"component---toggl-src-pages-track-customers-index-js","27":"component---toggl-src-pages-track-demo-request-confirmation-js","28":"component---toggl-src-pages-track-demo-request-js","29":"component---toggl-src-pages-track-device-unsupported-js","30":"component---toggl-src-pages-track-features-index-js","31":"component---toggl-src-pages-track-forgot-password-js","32":"component---toggl-src-pages-track-index-index-js","33":"component---toggl-src-pages-track-integrations-index-js","34":"component---toggl-src-pages-track-login-js","35":"component---toggl-src-pages-track-pricing-index-js","36":"component---toggl-src-pages-track-sso-link-account-js","37":"component---toggl-src-pages-track-sso-login-js","38":"component---toggl-src-pages-track-sso-must-link-js","39":"component---toggl-src-pages-track-toggl-button-login-js","40":"component---toggl-src-paid-ad-landing-pages-index-js","41":"component---toggl-src-personas-index-js","42":"component---toggl-src-signup-index-js","43":"component---toggl-src-templates-track-reset-password-js","44":"component---toggl-src-templates-track-unsubscribe-js","45":"component---toggl-src-webinars-index-js"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0d16ae931b73c","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"8fe7522e6d595642dbdb","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://public-assets.toggl.com/b/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
